import { QueryClientConfig } from '@tanstack/react-query';

export default {
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 3 },
  },
} as QueryClientConfig;
